import { useState } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { getImageUrl } from "../../../../../utils/image-helper/get-image-url";

type ModelNameHandlerProps = {
    defaultValue: string;
    onSave: (name: string) => void;
    editIconColor?: 'green' | 'black';
};

export const ModelNameHandler = ({ defaultValue, onSave, editIconColor = 'green' }: ModelNameHandlerProps) => {
    const [value, setValue] = useState(defaultValue);
    const [editMode, setEditMode] = useState(false);

    if (editMode) return (
        <div className='position-relative' onClick={(e) => e.stopPropagation()}>
            <input style={{ width: '100%', paddingRight: '30px' }} type='text' value={value} onChange={(e) => setValue(e.target.value)} />
            <CheckOutlined
                title='Mentés'
                style={{
                    color: 'green',
                    position: 'absolute',
                    right: '20px',
                    top: '5px'
                }}
                onClick={
                    () => {
                        onSave(value);
                        setEditMode(false);
                    }
                }
            />
            <CloseOutlined
                title='Elvetés'
                style={{
                    color: 'red',
                    position: 'absolute',
                    right: '3px',
                    top: '5px'
                }}
                onClick={
                    () => {
                        setValue(defaultValue);
                        setEditMode(false);
                    }
                }
            />
        </div>
    );

    let editIconSrc = '';
    if (editIconColor === 'black') editIconSrc = getImageUrl('edit-icon-black.png');
    else if (editIconColor === 'green') editIconSrc = getImageUrl('edit-icon.png');

    return (
        <>
            {defaultValue}
            &nbsp;
            <img
                src={editIconSrc}
                alt="edit-icon"
                title='Átnevezés'
                onClick={
                    (e) => {
                        e.stopPropagation();
                        setEditMode(true);
                    }
                }
                style={{ width: '20px' }}
            />
        </>
    );
};